// Version constant - synced from root package.json
export const APP_VERSION = '1.0.0';

